(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["algolia-search-result"] && !Shopify.designMode) return;
  try {
    
  // Back to top button scroll behavior
  (function () {
    let lastScrollPosition = 0;
    let scrolledDown = false;

    function handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Add class when scrolling down past 1000px
      if (currentScrollPosition >= 1000 && !scrolledDown) {
        document.body.classList.add('scrolled-down');
        scrolledDown = true;
      }
      // Remove class when scrolling up past 990px
      else if (currentScrollPosition <= 990 && scrolledDown) {
        document.body.classList.remove('scrolled-down');
        scrolledDown = false;
      }
      // Between 990-1000px, maintain current state (do nothing)

      lastScrollPosition = currentScrollPosition;
    }

    // Use throttle to improve performance
    let ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Initialize on load
    handleScroll();
  })();

  // Section highlighting for jump-to links with smooth sliding indicator
  (function () {
    const sections = document.querySelectorAll('.search-results-section, .search-results-header');
    const navLinks = document.querySelectorAll('.jump-to-section__link');
    const navList = document.querySelector('.jump-to-section__list');

    if (navLinks.length === 0 || !navList) return;

    // Create indicator element
    const indicator = document.createElement('div');
    indicator.className = 'jump-to-section__indicator';
    navList.appendChild(indicator);

    const updateIndicator = (activeLink) => {
      if (!activeLink) {
        indicator.style.width = '0';
        indicator.style.opacity = '0';
        return;
      }

      const listRect = navList.getBoundingClientRect();
      const linkRect = activeLink.getBoundingClientRect();

      indicator.style.left = `${linkRect.left - listRect.left + navList.scrollLeft}px`;
      indicator.style.width = `${linkRect.width}px`;
      indicator.style.opacity = '1';
    };

    // Calculate which section is active based on scroll position
    const calculateActiveSection = (scrollTop) => {
      // Get navigation height for offset calculation
      const navigation = document.querySelector('.search-results-navigation');
      const headerHeight = navigation ? navigation.offsetHeight : 0;
      const diff = 0; // Additional offset if needed

      // Remove active class from all links first
      navLinks.forEach((navLink) => navLink.classList.remove('active'));

      // Check each section and find which one is in view
      for (const link of navLinks) {
        const targetId = link.getAttribute('href').substring(1);
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          const topOffset = targetSection.offsetTop;
          const sectionHeight = targetSection.offsetHeight;
          
          // Check if scroll position is within this section's bounds
          // Using logic from test.js: scrollTop >= topOffset - headerHeight && scrollTop < topOffset - headerHeight + sectionHeight
          if (scrollTop >= Math.floor(topOffset - diff - headerHeight) && 
              scrollTop < Math.floor(topOffset - diff - headerHeight + sectionHeight)) {
            link.classList.add('active');
            updateIndicator(link);
            break; // Only one section should be active
          }
        }
      }
    };

    // Handle scroll events to update active state
    let scrollTimeout;
    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        calculateActiveSection(scrollTop);
      }, 50); // Debounce for performance
    };

    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Initialize on page load
    calculateActiveSection(window.pageYOffset || document.documentElement.scrollTop);

    // Add click handler to each navigation link
    navLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        const targetId = link.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          // Get navigation height for offset
          const navigation = document.querySelector('.search-results-navigation');
          const offset = navigation ? navigation.offsetHeight : 0;
          
          // Calculate target position with offset
          const targetPosition = targetElement.offsetTop - offset;
          
          // Smooth scroll to position
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });

    // Update indicator position on window resize
    window.addEventListener('resize', () => {
      const activeLink = document.querySelector('.jump-to-section__link.active');
      if (activeLink) {
        updateIndicator(activeLink);
      }
    });

    // Update indicator position on nav list scroll
    navList.addEventListener('scroll', () => {
      const activeLink = document.querySelector('.jump-to-section__link.active');
      if (activeLink) {
        updateIndicator(activeLink);
      }
    });
  })();

  document.addEventListener('DOMContentLoaded', () => {
    const headerIcon = document.querySelector('.header__icon--menu');
    if (headerIcon) {
      headerIcon.addEventListener('click', (e) => {
        const menuDrawerContainer = document.querySelector('.menu-drawer-container');
        if (!menuDrawerContainer) {
          return;
        }
        if (menuDrawerContainer.hasAttribute('open')) {
          setTimeout(() => {
            document.querySelector('.search-results-navigation').style.zIndex = '11';
          }, 300);
        } else {
          document.querySelector('.search-results-navigation').style.zIndex = '1';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-quick-filters"] && !Shopify.designMode) return;
  try {
    
  class QuickFiltersNavigation {
    constructor(container) {
      this.container = container;
     this.section = container.closest('.section-amb-quick-filters');
      this.nav = container.querySelector('.amb-quick-filters__nav');
      this.list = container.querySelector('.amb-quick-filters__list');
      this.leftArrow = container.querySelector('.amb-quick-filters__nav-arrow--left');
      this.rightArrow = container.querySelector('.amb-quick-filters__nav-arrow--right');

      this.scrollPosition = 0;
      this.itemWidth = 0;
      this.visibleWidth = 0;
      this.maxScroll = 0;
      this.headerHeight = 0;

      this.init();
    }

    init() {
      if (!this.list || !this.leftArrow || !this.rightArrow) return;

      this.bindEvents();
      this.updateHeaderHeight();
      this.checkOverflow();

      // Check overflow and header height on window resize
      window.addEventListener('resize', () => {
        this.updateHeaderHeight();
        this.checkOverflow();
      });
    }

    bindEvents() {
      this.leftArrow.addEventListener('click', () => this.scrollLeft());
      this.rightArrow.addEventListener('click', () => this.scrollRight());
    }

  updateHeaderHeight() {
    // Get header height by finding common header selectors
    const header = document.querySelector('header') || document.querySelector('.header');

    if (header) {
      this.headerHeight = header.offsetHeight;
    } else {
      // Fallback: assume header height is 0 or use a default
      this.headerHeight = 0;
    }

    // Update the section's top position
    if (this.section) {
      // Check if header has a sticky header-component element
      const stickyHeaderComponent = header?.querySelector('header-component[sticky]');

      if (stickyHeaderComponent) {
        const headerTopValue = parseFloat(getComputedStyle(header).top) || 0;
        this.section.style.top = `${this.headerHeight + headerTopValue}px`;
      } else {
        this.section.style.top = '0px';
      }
    }
  }

    checkOverflow() {
      if (window.innerWidth < 750) {
        // Mobile: Handle native scroll to active item
        this.scrollToActiveItemMobile();
        return;
      }

      const listWidth = this.list.scrollWidth;
      const navWidth = this.nav.offsetWidth;

      if (listWidth > navWidth) {
        this.container.classList.add('amb-quick-filters__container--has-overflow');
        this.setupScrolling();
      } else {
        this.container.classList.remove('amb-quick-filters__container--has-overflow');
        this.scrollPosition = 0;
        this.list.style.transform = 'translateX(0)';
        // Hide both arrows when no overflow
        this.leftArrow.classList.add('amb-quick-filters__nav-arrow--hidden');
        this.rightArrow.classList.add('amb-quick-filters__nav-arrow--hidden');
      }
    }

    setupScrolling() {
      this.visibleWidth = this.nav.offsetWidth;
      this.maxScroll = this.list.scrollWidth - this.visibleWidth;
      this.itemWidth = Math.min(200, this.visibleWidth / 3); // Scroll by ~1/3 of visible width

      // Scroll to active item on initialization
      this.scrollToActiveItem();

      this.updateArrowStates();
    }

    scrollToActiveItem() {
      const activeItem = this.list.querySelector('.amb-quick-filters__item--current');
      if (!activeItem) return;

      const itemRect = activeItem.getBoundingClientRect();
      const navRect = this.nav.getBoundingClientRect();
      const listRect = this.list.getBoundingClientRect();

      // Calculate the position of the active item relative to the container
      const itemPosition = itemRect.left - listRect.left;
      const itemWidth = itemRect.width;
      const visibleStart = navRect.left - listRect.left;
      const visibleEnd = visibleStart + this.visibleWidth;

      // Check if the item is already fully visible
      const itemStart = itemPosition;
      const itemEnd = itemPosition + itemWidth;

      if (itemStart >= visibleStart && itemEnd <= visibleEnd) {
        // Item is already fully visible, no need to scroll
        return;
      }

      // Calculate scroll position to center the active item
      const targetScroll = itemPosition - this.visibleWidth / 2 + itemWidth / 2;

      // Clamp the scroll position within bounds
      this.scrollPosition = Math.max(0, Math.min(this.maxScroll, targetScroll));

      // Apply the scroll immediately
      this.list.style.transform = `translateX(-${this.scrollPosition}px)`;
    }

    scrollToActiveItemMobile() {
      const activeItem = this.list.querySelector('.amb-quick-filters__item--current');
      if (!activeItem) return;

      // Use native scroll behavior on mobile
      const activeLink = activeItem.querySelector('.amb-quick-filters__link');
      if (activeLink) {
        // Use scrollIntoView to center the active item
        activeLink.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }

    scrollLeft() {
      this.scrollPosition = Math.max(0, this.scrollPosition - this.itemWidth);
      this.updateScroll();
    }

    scrollRight() {
      this.scrollPosition = Math.min(this.maxScroll, this.scrollPosition + this.itemWidth);
      this.updateScroll();
    }

    updateScroll() {
      this.list.style.transform = `translateX(-${this.scrollPosition}px)`;
      this.updateArrowStates();
    }

    updateArrowStates() {
      if (this.scrollPosition <= 0) {
        this.leftArrow.classList.add('amb-quick-filters__nav-arrow--hidden');
      } else {
        this.leftArrow.classList.remove('amb-quick-filters__nav-arrow--hidden');
      }

      if (this.scrollPosition >= this.maxScroll) {
        this.rightArrow.classList.add('amb-quick-filters__nav-arrow--hidden');
      } else {
        this.rightArrow.classList.remove('amb-quick-filters__nav-arrow--hidden');
      }
    }
  }

  // Initialize navigation for each quick filters section
  document.addEventListener('DOMContentLoaded', () => {
    const quickFiltersContainers = document.querySelectorAll('.amb-quick-filters__container');
    quickFiltersContainers.forEach((container) => {
      new QuickFiltersNavigation(container);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animated-counter"] && !Shopify.designMode) return;
  try {
    
  /**
   * Animated Counter Section Web Component
   */
  if (!customElements.get('animated-counter-section')) {
    class AnimatedCounterSection extends HTMLElement {
      constructor() {
        super();
        this.animationSpeeds = {
          slow: 2000,
          medium: 1000,
          fast: 500,
          'very-fast': 200,
        };
        this.hasAnimated = false;
        this.intersectionObserver = null;
      }

      connectedCallback() {
        this.#initializeCounters();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
      }

      #initializeCounters() {
        const animationTrigger = this.dataset.animationTrigger;
        const enableAnimationsRaw = this.dataset.enableAnimations;
        const enableAnimations = enableAnimationsRaw === 'true';

        // Temporary debug - check what we're actually getting
        if (enableAnimationsRaw !== 'true' && enableAnimationsRaw !== 'false') {
          console.warn('Unexpected enableAnimations value:', enableAnimationsRaw, 'Type:', typeof enableAnimationsRaw);
        }

        if (!enableAnimations) {
          // Show final values immediately without animation
          this.#showFinalValues();
          return;
        }

        switch (animationTrigger) {
          case 'scroll':
            this.#setupIntersectionObserver();
            break;
          case 'load':
            this.#startAnimations();
            break;
          case 'hover':
            this.addEventListener('mouseenter', this.#startAnimations.bind(this));
            break;
        }
      }

      #showFinalValues() {
        const counterItems = this.querySelectorAll('.animated-counter-item');
        const numberFormat = this.dataset.numberFormat;

        counterItems.forEach((item) => {
          const target = parseInt(item.dataset.target);
          const blockPrefix = item.dataset.prefix || '';
          const blockSuffix = item.dataset.suffix || '';
          const display = item.querySelector('.counter-number');
          const prefixElement = item.querySelector('.counter-prefix');
          const suffixElement = item.querySelector('.counter-suffix');

          // Use block prefix/suffix as-is (can be empty)
          const prefix = blockPrefix;
          const suffix = blockSuffix;

          // Format and display the final number immediately
          const formattedNumber = this.#formatNumber(target, numberFormat);

          // Update the main number span directly
          const mainNumberElement = display.querySelector('.counter-main-number');
          if (mainNumberElement) {
            mainNumberElement.textContent = formattedNumber;
          }

          // Update prefix and suffix based on whether they have values
          if (prefixElement) {
            prefixElement.textContent = prefix;
          }
          if (suffixElement) {
            suffixElement.textContent = suffix;
          }
        });
      }

      #setupIntersectionObserver() {
        const options = {
          threshold: 0.3,
          rootMargin: '0px 0px -10% 0px',
        };

        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasAnimated) {
              this.#startAnimations();
              this.hasAnimated = true;
            }
          });
        }, options);

        this.intersectionObserver.observe(this);
      }

      #startAnimations() {
        const enableAnimations = this.dataset.enableAnimations === 'true';

        // Double-check: if animations are disabled, show final values instead
        if (!enableAnimations) {
          this.#showFinalValues();
          return;
        }

        const counterItems = this.querySelectorAll('.animated-counter-item');
        const animationSpeed = this.animationSpeeds[this.dataset.animationSpeed] || 2000;
        const numberFormat = this.dataset.numberFormat;

        counterItems.forEach((item, index) => {
          // Stagger the animations
          setTimeout(() => {
            this.#animateCounter(item, animationSpeed, numberFormat);
          }, index * 150);
        });
      }

      async #animateCounter(counterItem, duration, format) {
        const enableAnimations = this.dataset.enableAnimations === 'true';

        // Final safeguard: if animations are disabled, don't animate
        if (!enableAnimations) {
          return;
        }

        const target = parseInt(counterItem.dataset.target);
        const blockPrefix = counterItem.dataset.prefix || '';
        const blockSuffix = counterItem.dataset.suffix || '';
        const display = counterItem.querySelector('.counter-number');
        const prefixElement = counterItem.querySelector('.counter-prefix');
        const suffixElement = counterItem.querySelector('.counter-suffix');

        // Use block prefix/suffix as-is (can be empty)
        const prefix = blockPrefix;
        const suffix = blockSuffix;

        // Skip animation only for zero values
        if (target === 0) {
          // Show zero immediately without animation
          const formattedNumber = this.#formatNumber(0, format);
          const mainNumberElement = display.querySelector('.counter-main-number');
          if (mainNumberElement) {
            mainNumberElement.textContent = formattedNumber;
          }

          if (prefixElement) {
            prefixElement.textContent = prefix;
          }
          if (suffixElement) {
            suffixElement.textContent = suffix;
          }
          return;
        }

        const startTime = performance.now();
        const startValue = 0; // Always start from 0 for both positive and negative numbers

        const animate = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);

          // Easing function for smooth animation
          const easeOut = 1 - Math.pow(1 - progress, 3);

          // Animate from 0 to target (works for both positive and negative numbers)
          const currentValue = Math.floor(startValue + (target - startValue) * easeOut);

          // Format and display the number
          const formattedNumber = this.#formatNumber(currentValue, format);

          // Update the main number span directly
          const mainNumberElement = display.querySelector('.counter-main-number');
          if (mainNumberElement) {
            mainNumberElement.textContent = formattedNumber;
          }

          // Update prefix and suffix based on whether they have values
          if (prefixElement) {
            prefixElement.textContent = prefix;
          }
          if (suffixElement) {
            suffixElement.textContent = suffix;
          }

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };

        // Respect reduced motion preferences
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const formattedNumber = this.#formatNumber(target, format);

          // Update the main number span directly
          const mainNumberElement = display.querySelector('.counter-main-number');
          if (mainNumberElement) {
            mainNumberElement.textContent = formattedNumber;
          }

          if (prefixElement) prefixElement.textContent = prefix;
          if (suffixElement) suffixElement.textContent = suffix;
          return;
        }

        requestAnimationFrame(animate);
      }

      #formatNumber(number, format) {
        switch (format) {
          case 'separators':
            return number.toLocaleString();
          case 'suffix':
            return number.toString();
          default:
            return number.toString();
        }
      }
    }

    customElements.define('animated-counter-section', AnimatedCounterSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baker-scrollable-video-content"] && !Shopify.designMode) return;
  try {
    
  /**
   * Synchronizes slideshow control dots with the number of slides
   * Removes excess dots when there are more dots than slides
   *
   * @param {HTMLElement} container - Container element to search within
   * @returns {number} Number of dots removed
   */
  function syncSlideshowDots(container) {
    const slides = container.querySelectorAll('slideshow-slide');
    const dots = container.querySelectorAll('.slideshow-controls__dots li');

    // Early return if no slides or dots found
    if (!slides.length || !dots.length) {
      return 0;
    }

    const slideCount = slides.length;
    const dotCount = dots.length;

    // Early return if dots don't exceed slides
    if (dotCount <= slideCount) {
      return 0;
    }

    const excessDots = dotCount - slideCount;
    let removedCount = 0;

    // Remove excess dots from the end
    for (let i = dotCount - 1; i >= slideCount; i--) {
      const dotToRemove = dots[i];
      if (dotToRemove && dotToRemove.parentNode) {
        dotToRemove.parentNode.removeChild(dotToRemove);
        removedCount++;
      }
    }

    return removedCount;
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Find all scrollable video content sections
    const scrollableVideoSections = document.querySelectorAll('.scrollable-video-content');

    scrollableVideoSections.forEach((section) => {
      const headingArrows = section.querySelectorAll('.scrollable-video-content__arrow');
      const slideshow = section.querySelector('.scrollable-video-content__carousel slideshow-component');

      // Function to check if all slides are visible and hide/show arrows accordingly
      function updateArrowVisibility() {
        if (!slideshow) return;

        const slides = slideshow.querySelectorAll('slideshow-slide');
        if (!slides.length) return;

        const slideshowRect = slideshow.getBoundingClientRect();

        // Check if all slides are fully visible within the slideshow container
        const allSlidesFullyVisible = Array.from(slides).every((slide) => {
          const slideRect = slide.getBoundingClientRect();

          // Check if slide is fully contained within the slideshow viewport
          return (
            slideRect.left >= slideshowRect.left &&
            slideRect.right <= slideshowRect.right &&
            slideRect.top >= slideshowRect.top &&
            slideRect.bottom <= slideshowRect.bottom
          );
        });

        // Hide custom arrows if all slides are fully visible on screen
        const customArrows = section.querySelector('.scrollable-video-content__custom-arrows');
        if (customArrows) {
          customArrows.style.display = allSlidesFullyVisible ? 'none' : 'flex';
        }
      }

      // Function to update arrow colors based on slide position
      function updateArrowColors() {
        if (!slideshow) return;

        const slides = slideshow.querySelectorAll('slideshow-slide');
        if (!slides.length) return;

        const slideshowRect = slideshow.getBoundingClientRect();

        // Check if first slide is fully visible in viewport
        const firstSlide = slides[0];
        const firstSlideRect = firstSlide?.getBoundingClientRect();
        const firstSlideFullyVisible =
          firstSlideRect && firstSlideRect.left >= slideshowRect.left && firstSlideRect.right <= slideshowRect.right;

        // Check if last slide is fully visible in viewport
        const lastSlide = slides[slides.length - 1];
        const lastSlideRect = lastSlide?.getBoundingClientRect();
        const lastSlideFullyVisible =
          lastSlideRect && lastSlideRect.left >= slideshowRect.left && lastSlideRect.right <= slideshowRect.right;

        // Update arrow styles - arrows are active when there's content to scroll to
        const updateArrowStyle = (arrow, isActive) => {
          if (!arrow) return;
          arrow.classList.toggle('scrollable-video-content__arrow--active', isActive);
          arrow.disabled = !isActive;
        };

        // Previous arrow is active when first slide is not fully visible (content to scroll left)
        updateArrowStyle(section.querySelector('.scrollable-video-content__arrow--previous'), !firstSlideFullyVisible);
        // Next arrow is active when last slide is not fully visible (content to scroll right)
        updateArrowStyle(section.querySelector('.scrollable-video-content__arrow--next'), !lastSlideFullyVisible);
      }

      // Initial setup
      updateArrowVisibility();
      updateArrowColors();

      // Sync slideshow dots with actual slide count
      if (slideshow) {
        // Wait for slideshow to be fully initialized
        setTimeout(() => {
          syncSlideshowDots(section);
        }, 100);
      }

      // Listen for window resize to update arrow visibility
      window.addEventListener('resize', updateArrowVisibility);

      // Listen for slide changes
      if (slideshow) {
        slideshow.addEventListener('slideshow:slide-changed', updateArrowColors);

        // Listen for aria-hidden changes on slideshow-slide elements
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
              updateArrowColors();
            }
          });
        });

        // Observe all slideshow-slide elements for aria-hidden changes
        const slides = slideshow.querySelectorAll('slideshow-slide');
        slides.forEach((slide) => {
          observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
        });
      }

      // Override slideshow step behavior to always step by 1 slide
      if (slideshow) {
        // Store original methods
        const originalNext = slideshow.next.bind(slideshow);
        const originalPrevious = slideshow.previous.bind(slideshow);

        // Override next method to always step by 1
        slideshow.next = function (event, options) {
          event?.preventDefault();
          this.select(this.current + 1, event, options);
        };

        // Override previous method to always step by 1
        slideshow.previous = function (event, options) {
          event?.preventDefault();
          this.select(this.current - 1, event, options);
        };
      }

      headingArrows.forEach((headingArrow) => {
        headingArrow.addEventListener('click', function (event) {
          event.preventDefault();

          const ref = headingArrow.getAttribute('ref');
          let carouselArrow;

          if (ref === 'next') {
            carouselArrow = section.querySelector('.scrollable-video-content__carousel .slideshow-control[ref="next"]');
          }

          if (ref === 'previous') {
            carouselArrow = section.querySelector(
              '.scrollable-video-content__carousel .slideshow-control[ref="previous"]'
            );
          }

          if (carouselArrow) {
            carouselArrow.click();
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bakers-main-blogs"] && !Shopify.designMode) return;
  try {
    
function ambSyncHeadMetaFromFetchedDocument(doc) {
  if (!doc?.head) return;

  const srcTitle = doc.querySelector('title');
  if (srcTitle?.textContent) {
    document.title = srcTitle.textContent.trim();
  }

  for (const [selector, attr] of [
    ['meta[name="description"]', 'content'],
    ['meta[property="og:title"]', 'content'],
    ['meta[property="og:description"]', 'content'],
    ['meta[name="twitter:title"]', 'content'],
    ['meta[name="twitter:description"]', 'content'],
  ]) {
    const src = doc.querySelector(selector);
    let dst = document.querySelector(selector);

    if (selector === 'meta[name="description"]' && !src?.hasAttribute(attr)) {
      if (dst) dst.remove();
      continue;
    }

    if (!src?.hasAttribute(attr)) continue;

    const value = src.getAttribute(attr);

    if (!dst && selector === 'meta[name="description"]') {
      dst = document.createElement('meta');
      dst.setAttribute('name', 'description');
      document.head.appendChild(dst);
    }

    if (dst) dst.setAttribute(attr, value);
  }
}

class BlogPagination {
  constructor() {
    this.container = document.querySelector('.blog-posts-container');
    this.paginationWrapper = document.querySelector('.pagination-wrapper');
    this.tagFilter = document.querySelector('.blog-tag-filter');
    this.isLoading = false;

    // Initialize selected tag from current URL
    // Get initial selected tag from URL (both query param and tagged format)
    const urlParams = new URLSearchParams(window.location.search);
    this.selectedTag = urlParams.get('tag') || this.getTagFromTaggedUrl() || '';

    var h1 = document.querySelector('h1');
    this.originalHeadingText = h1 ? (h1.dataset.originalText || h1.textContent) : '';

    this.init();
  }

  /**
   * Convert string to handleize format (similar to Shopify's handleize filter)
   * @param {string} str - String to handleize
   * @returns {string} Handleized string
   */
  handleize(str) {
    if (!str) return '';
    return str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '') // Remove special characters except spaces and hyphens
      .replace(/\s+/g, '-')     // Replace spaces with hyphens
      .replace(/-+/g, '-')      // Replace multiple hyphens with single hyphen
      .replace(/^-|-$/g, '');   // Remove leading/trailing hyphens
  }

  init() {

    // Intercept pagination link clicks
    document.addEventListener('click', this.handlePaginationClick.bind(this));

    // Handle tag filter clicks
    document.addEventListener('click', this.handleTagClick.bind(this));

    // Handle browser back/forward
    window.addEventListener('popstate', this.handlePopState.bind(this));

    // Set initial active state based on current URL
    if (this.selectedTag) {
      this.updateActiveTagByValue(this.selectedTag);
    }

    // Update pagination links with current tag
    this.updatePaginationLinks();
  }

  async handlePaginationClick(event) {
    const link = event.target.closest('.pagination__link');
    if (!link || link.classList.contains('pagination__link--current')) {
      return;
    }

    event.preventDefault();

    if (this.isLoading) return;

    const url = link.href;
    console.log('Debug - Pagination click:', {
      url: url,
      selectedTagBefore: this.selectedTag
    });

    // Update selectedTag from the tagged URL format
    this.selectedTag = this.getTagFromTaggedUrl(url) || '';

    console.log('Debug - After parsing URL:', {
      parsedTag: this.selectedTag,
      finalUrl: url
    });

    await this.loadPage(url, true, url);
  }

  async handleTagClick(event) {
    const tagPill = event.target.closest('.tag-pill');
    if (!tagPill || tagPill.classList.contains('tag-pill--active')) {
      return;
    }

    event.preventDefault();

    if (this.isLoading) return;

    const tag = tagPill.dataset.tag;

    // Determine which filter was clicked
    const shopifyBlock = tagPill.closest('.shopify-block');
    const isBottomFilter = shopifyBlock && shopifyBlock.id.includes('bottom-blogs-filter');

    // Update active state before loading
    this.updateActiveTag(tagPill);

    // Store the selected tag for later use
    this.selectedTag = tag;

    // Update pagination links immediately
    this.updatePaginationLinks();

    await this.loadPageWithTag(tag, isBottomFilter);
  }

  updateActiveTag(selectedPill) {
    // Remove active class from all pills
    const allPills = document.querySelectorAll('.tag-pill');
    allPills.forEach(pill => pill.classList.remove('tag-pill--active'));

    // Add active class to selected pill
    selectedPill.classList.add('tag-pill--active');
  }

  updateActiveTagByValue(tagValue) {
    // Remove active class from all pills
    const allPills = document.querySelectorAll('.tag-pill');
    allPills.forEach(pill => pill.classList.remove('tag-pill--active'));

    // Find and activate the pill with matching tag value
    const targetPill = document.querySelector(`[data-tag="${tagValue}"]`);
    if (targetPill) {
      targetPill.classList.add('tag-pill--active');
    } else if (tagValue === '' || tagValue === null || tagValue === undefined) {
      // If no tag or empty tag, activate "All" option
      const allPill = document.querySelector('[data-tag=""]');
      if (allPill) {
        allPill.classList.add('tag-pill--active');
      }
    }
  }

  getTagFromTaggedUrl(url = null) {
    // Use provided URL or current page URL
    const pathname = url ? (new URL(url, window.location.origin)).pathname : window.location.pathname;
    const taggedMatch = pathname.match(/\/tagged\/([^\/\?]+)/);
    return taggedMatch ? decodeURIComponent(taggedMatch[1]) : '';
  }

  updateHeading(tagHandle) {
    var h1 = document.querySelector('h1');
    if (!h1) return;

    if (!tagHandle) {
      h1.textContent = this.originalHeadingText;
      return;
    }

    var tagPill = document.querySelector('[data-tag="' + tagHandle + '"]');
    var displayName = tagPill ? tagPill.textContent.trim() : '';

    if (!displayName) {
      displayName = decodeURIComponent(tagHandle).replace(/-/g, ' ');
      displayName = displayName.charAt(0).toUpperCase() + displayName.slice(1);
    }

    var isRecipes = window.location.pathname.includes('/blogs/recipes');
    h1.textContent = isRecipes ? displayName + ' recipes' : displayName;
  }

  updatePaginationLinks() {
    // Update all pagination links to include current tag parameter
    const paginationLinks = document.querySelectorAll('.pagination__link');

    paginationLinks.forEach((link) => {
      try {
        // Handle both relative and absolute URLs
        const url = new URL(link.href, window.location.origin);
        let pathname = url.pathname.replace(/\/tagged\/[^\/]*$/, '');

        // Add current tag if we have one
        if (this.selectedTag && this.selectedTag !== '') {
          pathname += `/tagged/${this.handleize(this.selectedTag)}`;
        }

        // Rebuild the URL
        const newUrl = new URL(`${url.origin}${pathname}`);

        // Preserve any other query parameters (like page)
        url.searchParams.forEach((value, key) => {
          newUrl.searchParams.set(key, value);
        });

        // Update the link href
        link.href = newUrl.toString();
      } catch (error) {
        console.error('Error updating pagination link:', link.href, error);
      }
    });

    console.log('Debug - Updated pagination links with tag:', this.selectedTag);
  }

  triggerAutoExpand() {
    // Find all show more buttons
    const showMoreButtons = document.querySelectorAll('.show-more-btn');

    showMoreButtons.forEach((button) => {
      const shouldAutoExpand = button.dataset.shouldAutoExpand === 'true';
      const text = button.querySelector('.show-more-text');
      const showMoreText = button.dataset.showMoreText;
      const showLessText = button.dataset.showLessText;
      const isCollapsed = text && text.textContent.trim() === showMoreText.trim();
      const isExpanded = text && text.textContent.trim() === showLessText.trim();

      if (shouldAutoExpand && isCollapsed) {
        // Should expand and currently collapsed - expand it
        console.log('Debug - Auto-expanding show more button (tag in hidden section)');
        toggleShowMore(button);
      } else if (!shouldAutoExpand && isExpanded) {
        // Should NOT expand and currently expanded - collapse it
        console.log('Debug - Auto-collapsing show more button (tag in visible section)');
        toggleShowMore(button);
      }
    });
  }


  async handlePopState(event) {
    if (event.state && event.state.url) {
      await this.loadPage(event.state.url, false);
    }
  }

  async loadPageWithTag(tag, shouldScrollToTop = false) {
    const currentUrl = new URL(window.location.href);
    let blogPath = currentUrl.pathname.replace(/\/tagged\/[^\/]*$/, '');

    // Create fetch URL using Shopify's tagged format
    let fetchUrl;
    if (tag) {
      // Use Shopify's tagged URL format for API request
      fetchUrl = `${window.location.origin}${blogPath}/tagged/${this.handleize(tag)}`;
    } else {
      // Remove tag parameter (show all)
      fetchUrl = `${window.location.origin}${blogPath}`;
    }

    console.log('Debug - loadPageWithTag URLs:', {
      originalPath: currentUrl.pathname,
      cleanedPath: blogPath,
      tag: tag,
      finalUrl: fetchUrl,
      shouldScrollToTop: shouldScrollToTop
    });

    // Use the same URL for both fetch and display (Shopify default format)
    await this.loadPage(fetchUrl, true, fetchUrl, shouldScrollToTop);
  }

  async loadPage(url, pushState = true, displayUrl = null, shouldScrollToTop = false) {
    try {
      this.setLoadingState(true);

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Extract new content
      const newContainer = doc.querySelector('.blog-posts-container');
      const newPagination = doc.querySelector('.pagination-wrapper');
      const newTagFilter = doc.querySelector('.blog-tag-filter');


      if (newContainer) {
        // Replace content with fade effect
        await this.replaceContent(newContainer, newPagination, doc);

        ambSyncHeadMetaFromFetchedDocument(doc);

        // Update URL and history
        if (pushState) {
          const urlToShow = displayUrl || url;
          console.log('Debug - Updating browser URL:', {
            urlToShow: urlToShow,
            selectedTagBefore: this.selectedTag
          });

          history.pushState({ url: url }, '', urlToShow);

          // Update selectedTag from the display URL
          this.selectedTag = this.getTagFromTaggedUrl(urlToShow) || '';

          console.log('Debug - After URL update:', {
            selectedTagAfter: this.selectedTag,
            finalUrl: urlToShow
          });
        }

        var headingTag = this.getTagFromTaggedUrl(displayUrl || url) || '';
        if (!pushState) {
          this.selectedTag = headingTag;
          this.updateActiveTagByValue(headingTag);
        }
        this.updateHeading(headingTag);

        // Scroll to top of page if requested (bottom filter clicked)
        if (shouldScrollToTop) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        // Announce to screen readers
        this.announcePageChange(displayUrl || url);
      }

    } catch (error) {
      console.error('Failed to load page:', error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }

  async replaceContent(newContainer, newPagination, doc) {
    // Fade out current content
    this.container.style.opacity = '0.5';
    if (this.paginationWrapper) {
      this.paginationWrapper.style.opacity = '0.5';
    }
    if (this.tagFilter) {
      this.tagFilter.style.opacity = '0.5';
    }

    // Small delay for visual feedback
    await new Promise(resolve => setTimeout(resolve, 150));

    // Replace content
    this.container.replaceWith(newContainer);

    // Replace pagination if it exists
    if (this.paginationWrapper && newPagination) {
      this.paginationWrapper.replaceWith(newPagination);
      this.paginationWrapper = newPagination;
    } else if (this.paginationWrapper && !newPagination) {
      // Hide pagination if new content doesn't have it
      this.paginationWrapper.style.display = 'none';
    } else if (!this.paginationWrapper && newPagination) {
      // Add pagination if it didn't exist before
      this.container.insertAdjacentElement('afterend', newPagination);
      this.paginationWrapper = newPagination;
    }

    // Replace tag filters to get updated data-should-auto-expand attributes
    const currentTagFilters = document.querySelectorAll('.blog-tag-filter');
    const newTagFilters = doc.querySelectorAll('.blog-tag-filter');

    if (currentTagFilters.length === newTagFilters.length) {
      currentTagFilters.forEach((currentFilter, index) => {
        const newFilter = newTagFilters[index];
        if (newFilter) {
          currentFilter.replaceWith(newFilter.cloneNode(true));
        }
      });
    }

    // Update references
    this.container = newContainer;
    this.tagFilter = document.querySelector('.blog-tag-filter');

    // Update all pagination links to include current tag
    this.updatePaginationLinks();

    // Trigger auto-expand for show more buttons if needed
    this.triggerAutoExpand();

    // Fade in new content
    this.container.style.opacity = '1';
    if (this.paginationWrapper) {
      this.paginationWrapper.style.opacity = '1';
    }
    if (this.tagFilter) {
      this.tagFilter.style.opacity = '1';
    }
  }

  setLoadingState(loading) {
    this.isLoading = loading;

    if (loading) {
      // Add loading classes for styling
      document.body.classList.add('blog-pagination-loading');
      document.body.classList.add('blog-tag-filtering');

      // Disable pagination links
      const links = document.querySelectorAll('.pagination__link');
      links.forEach(link => link.style.pointerEvents = 'none');

      // Disable tag pills
      const tagPills = document.querySelectorAll('.tag-pill');
      tagPills.forEach(pill => pill.style.pointerEvents = 'none');
    } else {
      // Remove loading state
      document.body.classList.remove('blog-pagination-loading');
      document.body.classList.remove('blog-tag-filtering');

      // Re-enable pagination links
      const links = document.querySelectorAll('.pagination__link');
      links.forEach(link => link.style.pointerEvents = 'auto');

      // Re-enable tag pills
      const tagPills = document.querySelectorAll('.tag-pill');
      tagPills.forEach(pill => pill.style.pointerEvents = 'auto');
    }
  }

  announcePageChange(url) {
    // Create or update live region for screen readers
    let liveRegion = document.getElementById('pagination-live-region');
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.id = 'pagination-live-region';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.className = 'visually-hidden';
      document.body.appendChild(liveRegion);
    }

    // Extract page number and tag from URL
    const urlObj = new URL(url);
    const page = urlObj.searchParams.get('page') || '1';
    const tag = this.getTagFromTaggedUrl(url);

    let message = `Page ${page} loaded`;
    if (tag) {
      message += ` for tag "${tag}"`;
    }

    liveRegion.textContent = message;
  }

  showError() {
    // Simple error handling - could be enhanced
    const errorMsg = document.createElement('div');
    errorMsg.className = 'pagination-error';
    errorMsg.textContent = 'Failed to load page. Please try again.';
    errorMsg.style.cssText = 'color: #dc3545; text-align: center; padding: 1rem; margin: 1rem 0;';

    this.container.appendChild(errorMsg);

    // Auto-remove error after 5 seconds
    setTimeout(() => {
      if (errorMsg.parentNode) {
        errorMsg.remove();
      }
    }, 5000);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new BlogPagination());
} else {
  new BlogPagination();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function waitForSwiper() {
    return new Promise((resolve, reject) => {
      // If Swiper is already loaded, resolve immediately
      if (typeof window.Swiper !== 'undefined') {
        resolve(window.Swiper);
        return;
      }

      // Set up a timeout to prevent infinite waiting
      const timeout = setTimeout(() => {
        reject(new Error('Swiper script failed to load within timeout period'));
      }, 10000); // 10 second timeout

      // Check for Swiper availability
      const checkSwiper = () => {
        if (typeof window.Swiper !== 'undefined') {
          clearTimeout(timeout);
          resolve(window.Swiper);
        } else {
          // Check again in 100ms
          setTimeout(checkSwiper, 100);
        }
      };

      // Start checking
      checkSwiper();
    });
  }
  waitForSwiper()
    .then((Swiper) => {
    const swiperElement = document.querySelector('[data-blog-posts-slider]');

    if (swiperElement) {
      // Initialize Swiper for blog posts using core API
      const swiper = new Swiper(swiperElement, {
        // Core settings
        slidesPerView: 'auto',
        spaceBetween: 24,
        loop: false,
        autoHeight: false,
        grabCursor: true,
        breakpoints: {
          1280: {
            spaceBetween: 40
          }
        },
        // Navigation
        navigation: {
          nextEl: '.blog-posts-slider__nav--next',
          prevEl: '.blog-posts-slider__nav--prev',
        },

        // Pagination
        pagination: {
          el: '.blog-posts-slider__pagination',
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        },

        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide',
        },

        // Performance
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
      });
    }
  })
  .catch((error) => {
    console.error('Swiper script failed to load:', error);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobs-recipe-blog-listing"] && !Shopify.designMode) return;
  try {
    
  // Mobile navigation handling
  document.addEventListener('DOMContentLoaded', function() {
    const dropdown = document.querySelector('.cobs-recipe-dropdown');
    if (!dropdown) return;

    const button = dropdown.querySelector('.cobs-recipe-dropdown__button');
    const content = dropdown.querySelector('.cobs-recipe-dropdown__content');
    const options = dropdown.querySelectorAll('.cobs-recipe-dropdown__option');

    if (!button || !content) return;

    // Toggle dropdown
    function toggleDropdown() {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', !isExpanded);
      content.hidden = isExpanded;

      if (!isExpanded) {
        // Add escape key listener when dropdown opens
        document.addEventListener('keydown', handleEscapeKey);
        // Add click outside listener
        document.addEventListener('click', handleClickOutside);
      } else {
        // Remove listeners when dropdown closes
        document.removeEventListener('keydown', handleEscapeKey);
        document.removeEventListener('click', handleClickOutside);
      }
    }

    // Handle escape key to close dropdown
    function handleEscapeKey(event) {
      if (event.key === 'Escape') {
        button.setAttribute('aria-expanded', 'false');
        content.hidden = true;
        button.focus();
        document.removeEventListener('keydown', handleEscapeKey);
        document.removeEventListener('click', handleClickOutside);
      }
    }

    // Handle click outside to close dropdown
    function handleClickOutside(event) {
      if (!dropdown.contains(event.target)) {
        button.setAttribute('aria-expanded', 'false');
        content.hidden = true;
        document.removeEventListener('keydown', handleEscapeKey);
        document.removeEventListener('click', handleClickOutside);
      }
    }

    // Button click handler
    button.addEventListener('click', toggleDropdown);

    // Button keyboard handler
    button.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleDropdown();
      }
    });

    // Option keyboard navigation
    options.forEach((option, index) => {
      option.addEventListener('keydown', function(event) {
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            const nextOption = options[index + 1] || options[0];
            nextOption.focus();
            break;
          case 'ArrowUp':
            event.preventDefault();
            const prevOption = options[index - 1] || options[options.length - 1];
            prevOption.focus();
            break;
          case 'Home':
            event.preventDefault();
            options[0].focus();
            break;
          case 'End':
            event.preventDefault();
            options[options.length - 1].focus();
            break;
          case 'Escape':
            event.preventDefault();
            button.setAttribute('aria-expanded', 'false');
            content.hidden = true;
            button.focus();
            document.removeEventListener('keydown', handleEscapeKey);
            document.removeEventListener('click', handleClickOutside);
            break;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer {
    constructor(element) {
      this.element = element;
      this.targetDate = null;
      this.interval = null;
      this.init();
    }

    init() {
      this.showHeadline();
      this.setupCountdown();
      this.startCountdown();
    }

    setupCountdown() {
      const targetDateStr = this.element.dataset.targetDate;
      const targetTimeStr = this.element.dataset.targetTime;

      if (!targetDateStr || !targetTimeStr) {
        this.showFallback();
        return;
      }

      // Parse date and time components explicitly for local timezone
      // This ensures the countdown uses the visitor's local time, not UTC
      const [year, month, day] = targetDateStr.split('-').map(Number);
      const [hours, minutes] = targetTimeStr.split(':').map(Number);

      // Create date in LOCAL timezone (month is 0-indexed in JavaScript)
      this.targetDate = new Date(year, month - 1, day, hours, minutes, 0);

      if (isNaN(this.targetDate.getTime())) {
        this.showFallback();
        return;
      }
    }

    startCountdown() {
      if (!this.targetDate) return;

      // Check immediately if countdown has already ended
      const now = new Date().getTime();
      const distance = this.targetDate.getTime() - now;

      if (distance <= 0) {
        this.showEnded();
        return;
      }

      // Update immediately, then start interval
      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }

    updateCountdown() {
      const now = new Date().getTime();
      const distance = this.targetDate.getTime() - now;

      if (distance <= 0) {
        this.showEnded();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.updateDisplay(days, hours, minutes, seconds);
    }

    updateDisplay(days, hours, minutes, seconds) {
      this.updateDigits('days', days);
      this.updateDigits('hours', hours);
      this.updateDigits('minutes', minutes);
      this.updateDigits('seconds', seconds);
    }

    updateDigits(unit, value) {
      const paddedValue = this.padZero(value);
      const tens = paddedValue[0];
      const ones = paddedValue[1];

      const tensEl = this.element.querySelector(`[data-countdown-${unit}-tens]`);
      const onesEl = this.element.querySelector(`[data-countdown-${unit}-ones]`);

      if (tensEl) tensEl.textContent = tens;
      if (onesEl) onesEl.textContent = ones;
    }

    padZero(num) {
      return num.toString().padStart(2, '0');
    }

    showEnded() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }

      // Hide the headline text
      const headlineEl = this.element.querySelector('[data-countdown-headline]');
      const endedEl = this.element.querySelector('[data-countdown-ended]');

      if (headlineEl) {
        headlineEl.hidden = true;
      }

      if (endedEl) {
        endedEl.hidden = false;
      }
    }

    showFallback() {
      // Hide the headline text
      const headlineEl = this.element.querySelector('[data-countdown-headline]');
      const fallbackEl = this.element.querySelector('[data-countdown-fallback]');
      const displayContainer = this.element.querySelector('.countdown-timer__display-container');

      if (headlineEl) {
        headlineEl.hidden = true;
      }

      if (displayContainer) {
        displayContainer.hidden = true;
      }

      if (fallbackEl) {
        fallbackEl.hidden = false;
      }
    }

    showHeadline() {
      const headlineEl = this.element.querySelector('[data-countdown-headline]');
      const fallbackEl = this.element.querySelector('[data-countdown-fallback]');
      const endedEl = this.element.querySelector('[data-countdown-ended]');

      if (headlineEl) {
        headlineEl.hidden = false;
      }

      if (fallbackEl) {
        fallbackEl.hidden = true;
      }

      if (endedEl) {
        endedEl.hidden = true;
      }
    }

    destroy() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

  // Initialize all countdown timers on the page
  document.addEventListener('DOMContentLoaded', () => {
    const countdownElements = document.querySelectorAll('.countdown-timer__element');

    for (const element of countdownElements) {
      new CountdownTimer(element);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
